export * from './src/ai.assist.data.widget'